<template>
    <div class="container bg-light position-fixed top-50 start-50 translate-middle w-75 border border-danger p-3"
        style="border-radius: 10px">
        <div class="container overflow-auto w-100" style="max-height:80vh">
            <div class="container table-responsive">
                <button class="btn-close float-end mt-3" @click.prevent="close"></button>
                <h3 class="mt-3"><strong> Información previa de la forma </strong></h3>
                <table class="table table-bordered my-auto mx-auto">
                    <thead>
                        <tr>
                            <th scope="col">Grupo de formas asociada:</th>
                            <td scope="col"> <strong><i>{{ imgSheetFormFamilyName }}</i></strong></td>
                            <th scope="col">Nombre de la forma: </th>
                            <td scope="col">{{ imgSheetForm.imgForm }}</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">Número de distancias:</th>
                            <td>{{ imgSheetForm.imgDistances }}</td>
                            <th>Número de ángulos:</th>
                            <td>{{ imgSheetForm.imgAngles }}</td>
                        </tr>
                        <tr>
                            <th scope="row">Número de diámetros:</th>
                            <td>{{ imgSheetForm.imgDiameters }}</td>
                            <th>Número de radios</th>
                            <td>{{ imgSheetForm.imgRadius }}</td>
                        </tr>
                        <tr>
                            <th>Fórmula para el cálculo del largo:</th>
                            <td>{{ imgSheetForm.imgConceptionLength }}</td>
                            <th scope="row">Fórmula para el cálculo del ancho:</th>
                            <td>{{ imgSheetForm.imgConceptionWidth }}</td>
                        </tr>
                    </tbody>
                </table>
                <table class="table table-hover table-bordered my-2 mx-auto">
                    <tbody>
                        <tr>
                            <th>Forma</th>
                            <th colspan="4"><i> Servicios </i></th>
                        </tr>
                        <tr>
                            <th rowspan="12" class="p-2"> <img v-if="imgSheetForm && imgSheetForm.imgFile"
                                    :src="serverUrl + 'images/forms/' + imgSheetForm.imgFile" class="my-3 mx-2"
                                    style="max-width: 300px; max-height: 300px;" />
                            </th>
                        </tr>
                        <tr>
                            <th colspan="2">Cantidad de dobleces:</th>
                            <td colspan="2">{{ imgSheetForm.imgServiceFold }}</td>
                        </tr>
                        <tr>
                            <th colspan="2">Corte con cizalla:</th>
                            <td colspan="2">{{ imgSheetForm.imgServiceShearCut }}</td>
                        </tr>
                        <tr>
                            <th colspan="2">Fórmula para el cálculo de corte con cizalla:</th>
                            <td colspan="2">{{ imgSheetForm.imgServiceShearCutConception }}</td>
                        </tr>
                        <tr>
                            <th colspan="2">Corte con plasma:</th>
                            <td colspan="2">{{ imgSheetForm.imgServicePlasmaCutting }}</td>
                        </tr>
                        <tr>
                            <th colspan="2">Corte con láser:</th>
                            <td colspan="2">{{ imgSheetForm.imgServiceLaserCutting }}</td>
                        </tr>
                        <tr>
                            <th colspan="2">Oxicorte:</th>
                            <td colspan="2">{{ imgSheetForm.imgServiceFlameCutting }}</td>
                        </tr>
                        <tr>
                            <th colspan="2">Fórmula para el cálculo de los servicios de plasma, lasér y oxicorte:</th>
                            <td colspan="2">{{ imgSheetForm.imgOtherCuttingServicesConception }}</td>
                        </tr>
                        <tr>
                            <th>Rolado:</th>
                            <td>{{ imgSheetForm.imgServiceRolled }}</td>
                            <th>Roaldo cónico:</th>
                            <td>{{ imgSheetForm.imgServiceRolledConical }}</td>
                        </tr>
                        <tr>
                            <th>Soldadura electrodo:</th>
                            <td>{{ imgSheetForm.imgServiceWeldingElectrode }}</td>
                            <th>Soldadura MIG:</th>
                            <td>{{ imgSheetForm.imgServiceWeldingMig }}</td>
                        </tr>
                        <tr>
                            <th>Abombado:</th>
                            <td>{{ imgSheetForm.imgServiceConvex }}</td>
                            <th>Pestañado:</th>
                            <td>{{ imgSheetForm.imgServiceEyelashed }}</td>
                        </tr>
                        <tr>
                            <th>Punzonado menor a 40mm:</th>
                            <td>{{ imgSheetForm.imgServicePunching1 }}</td>
                            <th>Punzonado mayor a 40mm:</th>
                            <td>{{ imgSheetForm.imgServicePunching2 }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="container table-responsive">
                <h3 class="mt-3"> <strong> Editar forma </strong></h3>
                <p> <strong>Nota: </strong><mark><i>No podrá editar el grupo de formas asociado para esta
                            forma.</i>
                    </mark></p>
                <p><mark>Además, tenga presente que luego de hacer clic en el botón "Actualizar forma", la información que
                        sumistre en el siguiente espacio sutituirá por completo la información previa de la forma.</mark>
                </p>
                <p>
                    <strong>Atención: </strong><mark> <i>Los campos que se encuentren vacios al momento de hacer clic en el
                            botón "Actualizar forma", contarán como
                            modifaciones.</i></mark>
                </p>
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <h5 class="requiredFields">*</h5>
                            </td>
                            <th colspan="2">Nuevo nombre para la forma:</th>
                            <td colspan="4"><input type="text" v-model="editImageForm" class="form-control"
                                    id="editImageForm" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <h5 class="requiredFields">*</h5>
                            </td>
                            <th colspan=""> Nueva imagen para la forma:</th>
                            <td colspan="4"> <input type="file" class="form-control" id="editImageFile" ref="file"
                                    @change="previewFile" />
                            </td>
                            <td colspan="2">
                                <input class="form-check-input" type="checkbox" role="switch" id="imageFile"
                                    v-model="newImageFileAvailable" />
                                <i> Mantener imágen previa de la forma.</i>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="8">
                                <h5 class="mt-3"><i>Actualizar propiedades de la forma</i></h5>
                            </td>
                        </tr>
                        <tr>
                            <th>Nueva cantidad de distancias:</th>
                            <td>
                                <input type="number" min="0" v-model="editImageDistances" class="form-control"
                                    id="editImageDistances" />
                            </td>
                            <th>Nueva cantidad de ángulos</th>
                            <td>
                                <input type="number" min="0" v-model="editImageAngles" class="form-control"
                                    id="editImageAngles" />
                            </td>
                            <th>Nueva cantidad de diámetros:</th>
                            <td> <input type="number" min="0" v-model="editImageDiameters" class="form-control"
                                    id="editImageDiameters" /></td>
                            <th>Nueva cantidad de radios </th>
                            <td>
                                <input type="number" min="0" v-model="editImageRadius" class="form-control"
                                    id="editImageRadius" />
                            </td>
                        </tr>
                        <tr>
                            <td colspan="8">
                                <h5 class="mt-3"><i>Actualizar formulación de la forma para el calculo de su desarrollo</i>
                                </h5>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <h5 class="requiredFields">*</h5>
                            </td>
                            <th colspan="">Nueva fórmula para el largo:</th>
                            <td colspan="2">
                                <input type="text" v-model="editConceptionLength" class="form-control"
                                    id="editConceptionLength" v-bind:disabled="notChangeConceptionLength" />
                            </td>
                            <td>
                                <h5 class="requiredFields">*</h5>
                            </td>
                            <th colspan="">Nueva fórmula para el ancho:</th>
                            <td colspan="2">
                                <input type="text" v-model="editConceptionWidth" class="form-control"
                                    id="editConceptionWidth" v-bind:disabled="notChangeConceptionWidth" />
                            </td>
                        </tr>
                        <tr>
                            <td colspan="4">
                                <mark><input class="form-check-input" type="checkbox" role="switch"
                                        id="notChangeConceptionLength" v-model="notChangeConceptionLength" />
                                    <i> Mantener fórmula para el cálculo del largo previa.</i></mark>
                            </td>
                            <td colspan="4">
                                <mark><input class="form-check-input" type="checkbox" role="switch"
                                        id="notChangeConceptionWidth" v-model="notChangeConceptionWidth" />
                                    <i> Mantener fórmula para el cálculo del ancho previa.</i></mark>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="8">
                                <h5 class="mt-3"><i> Actualizar servicios requeridos por la forma</i></h5>
                            </td>
                        </tr>
                        <tr class="p-3">
                            <td></td>
                            <td></td>
                            <th colspan="2">Cantidad de dobleces:</th>
                            <td colspan="2"><input type="number" min="0" v-model="editImgServiceFold" class="form-control"
                                    id="editImgServiceFold" /></td>
                        </tr>
                        <tr class="p-3">
                            <th>Corte con cizalla:</th>
                            <td>
                                <input class="form-check-input ms-2 mt-2" type="checkbox" role="switch"
                                    id="imgSeviceShearCut" v-model="editImgServiceShearCut" />
                                <label class="form-check-label ms-4 mt-1" for="editImgServiceShearCut">Aplica</label>
                            </td>
                            <th>Corte con plasma:</th>
                            <td><input class="form-check-input ms-2 mt-2" type="checkbox" role="switch"
                                    id="imgSevicePlasmaCutting" v-model="editImgServicePlasmaCutting" />
                                <label class="form-check-label ms-4 mt-1" for="editImgServicePlasmaCutting">Aplica</label>
                            </td>
                            <th>Corte con láser:</th>
                            <td><input class="form-check-input ms-2 mt-2" type="checkbox" role="switch"
                                    id="imgSeviceLaserCutting" v-model="editImgServiceLaserCutting" />
                                <label class="form-check-label ms-4 mt-1" for="editImgServiceLaserCutting">Aplica</label>
                            </td>
                            <th>Oxicorte:</th>
                            <td><input class="form-check-input ms-2 mt-2" type="checkbox" role="switch"
                                    id="imgSeviceFlamingCut" v-model="editImgServiceFlamingCut" />
                                <label class="form-check-label ms-4 mt-1" for="editImgServiceFlamingCut">Aplica</label>
                            </td>
                        </tr>
                        <tr class="p-3">
                            <td>
                                <h5 class="requiredFields">*</h5>
                            </td>
                            <th colspan="">Nueva fórmula para el cálculo del servicio de corte con cizalla: </th>
                            <td colspan="2">
                                <input type="text" min="0" v-model="editImgServiceShearCutConception"
                                    v-bind:disabled="shearCutConceptionFlag || notChangeShearCutConception"
                                    class="form-control" id="editShearCutConception" />
                            </td>
                            <td>
                                <h5 class="requiredFields">*</h5>
                            </td>
                            <th colspan="">Nueva fórmula para el cálculo de los servicios de plasma, lasér y oxicorte:
                            </th>
                            <td colspan="2">
                                <input type="text" min="0" v-model="editOtherCuttingServicesConception"
                                    v-bind:disabled="otherCutServicesConceptionFlag || notChangeOtherCutServicesConception"
                                    class="form-control" id="editOtherServicesConception" />
                            </td>
                        </tr>
                        <tr class="p-3">
                            <td colspan="4">
                                <mark><input class="form-check-input" type="checkbox" role="switch"
                                        id="imgNotChangeConception1" v-model="notChangeShearCutConception" />
                                    <i> Mantener fórmula para el cálculo del servicio de corte con cizalla
                                        previa.</i></mark>
                            </td>
                            <td colspan="4">
                                <mark><input class="form-check-input" type="checkbox" role="switch"
                                        id="imgNotChangeConception2" v-model="notChangeOtherCutServicesConception" />
                                    <i> Mantener fórmula para el cálculo de los servicios de plasma, lasér y oxicorte
                                        previa.</i></mark>
                            </td>
                        </tr>
                        <tr class="p-3">
                            <th>Rolado: recto:</th>
                            <td><input class="form-check-input ms-2 mt-2" type="checkbox" role="switch" id="imgSeviceRolled"
                                    v-model="editImgServiceRolled" />
                                <label class="form-check-label ms-4 mt-1" for="editImgServiceRolled">Aplica</label>
                            </td>
                            <th>Rolado cónico:</th>
                            <td>
                                <input class="form-check-input ms-2 mt-2" type="checkbox" role="switch"
                                    id="imgSeviceRolledC" v-model="editImgServiceRolledC" />
                                <label class="form-check-label ms-4 mt-1" for="editImgServiceRolledC">Aplica</label>
                            </td>
                            <th>Soldadura electrodo:</th>
                            <td>
                                <input class="form-check-input ms-2 mt-2" type="checkbox" role="switch"
                                    id="imgSeviceWeldingElect" v-model="imgServiceWeldingElect" />
                                <label class="form-check-label ms-4 mt-1" for="imgServiceWeldingElect">Aplica</label>
                            </td>
                            <th>Soldadura <i>MIG</i>:</th>
                            <td>
                                <input class="form-check-input ms-2 mt-2" type="checkbox" role="switch"
                                    id="imgSeviceWeldingMig" v-model="editImgServiceWeldingMig" />
                                <label class="form-check-label ms-4 mt-1" for="editImgServiceWeldingMig">Aplica</label>
                            </td>
                        </tr>
                        <tr class="p-3">
                            <th>Pestañado:</th>
                            <td>
                                <input class="form-check-input ms-2 mt-2" type="checkbox" role="switch"
                                    id="imgSeviceEyelashed" v-model="editImgServiceEyelashed" disabled />
                                <label class="form-check-label ms-4 mt-1" for="editImgServiceEyelashed">Aplica</label>
                            </td>
                            <th>Abombado:</th>
                            <td>
                                <input class="form-check-input ms-2 mt-2" type="checkbox" role="switch" id="imgSeviceConvex"
                                    v-model="editImgServiceConvex" disabled />
                                <label class="form-check-label ms-4 mt-1" for="editImgServiceConvex">Aplica</label>
                            </td>
                            <th>Punzonado menor a 40mm:</th>
                            <td>
                                <input type="number" min="0" v-model="editImgServicePunching1" class="form-control"
                                    id="editImgServicePunching1" />
                            </td>
                            <th>Punzonado mayor a 40mm:</th>
                            <td>
                                <input type="number" min="0" v-model="editImgServicePunching2" class="form-control"
                                    id="editImgServicePunching2" />
                            </td>
                        </tr>
                        <tr>
                            <td colspan="8">
                                <mark>
                                    <input class="form-check-input" type="checkbox" role="switch" id="imageFile"
                                        v-model="newServicesAvailable" />
                                    <i> Mantener <strong>todos</strong> los servicios previos.</i>
                                </mark>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <button class="btn btn-danger mt-2 mb-3 mx-auto" @click.prevent="saveChanges()">
                    Actualizar forma
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
    props: {
        sendImageId: Number,
    },
    data() {
        return {
            serverUrl: RUTA_SERVIDOR,
            //LastInfo
            imgSheetForm: [],
            imgSheetFormFamilyName: "",
            //Edit Fields
            editImageForm: "",
            editImageDistances: 0,
            editImageAngles: 0,
            editImageRadius: 0,
            editImageDiameters: 0,
            editImgServiceFold: 0,
            editImgServiceShearCut: false,
            editImgServiceFlamingCut: false,
            editImgServicePlasmaCutting: false,
            editImgServiceLaserCutting: false,
            editImgServiceWeldingElect: false,
            editImgServiceWeldingMig: false,
            editImgServiceRolled: false,
            editImgServiceRolledC: false,
            editImgServicePunching1: 0,
            editImgServicePunching2: 0,
            editImgServiceConvex: false,
            editImgServiceEyelashed: false,
            editImageFile: undefined,
            editCurrentFile: undefined,
            editConceptionLength: "",
            editConceptionWidth: "",
            editImageOrder: 0,
            //New fields 
            editImgServiceShearCutConception: "",
            editOtherCuttingServicesConception: "",
            shearCutConceptionFlag: false,
            otherCutServicesConceptionFlag: false,
            //Optimización para en caso de no actualizar la imágen ni modificar las fórmulas (Todas) que ya son funcionales
            newImageFileAvailable: false,
            notChangeShearCutConception: false,
            notChangeOtherCutServicesConception: false,
            notChangeConceptionLength: false,
            notChangeConceptionWidth: false,
            newServicesAvailable: false,
        };
    },
    watch: {
        sendImageId(newVal) {
            if (newVal !== null) {
                this.getSheetInfo();
            }
        },
    },
    methods: {
        previewFile(event) {
            // this.editImageFile = event.target.files;
            // this.editImageFile2 = event.target.files[0];
            // console.log(this.editImageFile);
            // console.log(this.editImageFile2);
            this.editImageFile = this.$refs.file.files;
            // console.log(this.editImageFile);
            this.editCurrentFile = this.editImageFile.item(0);
            // console.log(this.editCurrentFile);
        },
        async saveChanges() {
            if (this.editImageForm === "" || (this.editConceptionLength == "" && !this.notChangeConceptionLength) || (this.editConceptionWidth == "" && !this.notChangeConceptionWidth) ||
                (this.editImgServiceShearCutConception == "" && !this.notChangeShearCutConception) || (this.editOtherCuttingServicesConception == "" && !this.notChangeOtherCutServicesConception)) {
                alert("Campos vacios, por favor complete aquellos que son obligatorios pimero.")
            } else {
                let formData = new FormData();
                formData.append("sheet_image_id", this.sendImageId);
                formData.append("editImageForm", this.editImageForm);
                if (this.newImageFileAvailable) {
                    console.log(this.newImageFileAvailable);
                    formData.delete("editImageFile");
                    formData.delete("editImageName");
                } else {
                    formData.append("editImageFile", this.editCurrentFile);
                    formData.append("editImageName", this.editCurrentFile.name);
                }
                formData.append("editImageDistances", this.editImageDistances);
                formData.append("editImageAngles", this.editImageAngles);
                formData.append("editImageDiameters", this.editImageDiameters);
                formData.append("editImageRadius", this.editImageRadius);
                if (this.newServicesAvailable) {
                    formData.delete("editImgServiceFold");
                    formData.delete("editImgServiceShearCut");
                    formData.delete("editImgServiceFlameCutting");
                    formData.delete("editImgServicePlasmaCutting");
                    formData.delete("editImgServiceLaserCutting");
                    formData.delete("editImgServiceWeldingElectrode");
                    formData.delete("editImgServiceWeldingMig");
                    formData.delete("editImgServiceRolled");
                    formData.delete("editImgServiceRolledC");
                    formData.delete("editImgServicePunching1");
                    formData.delete("editImgServicePunching2");
                    formData.delete("editImgServiceConvex");
                    formData.delete("editImgServiceEyelashed");
                } else {
                    formData.append("editImgServiceFold", this.editImgServiceFold);
                    formData.append(
                        "editImgServiceShearCut",
                        this.editImgServiceShearCut ? "aplica" : "no_aplica"
                    );
                    formData.append(
                        "editImgServiceFlameCutting",
                        this.editImgServiceFlamingCut ? "aplica" : "no_aplica"
                    );
                    formData.append(
                        "editImgServicePlasmaCutting",
                        this.editImgServicePlasmaCutting ? "aplica" : "no_aplica"
                    );
                    formData.append(
                        "editImgServiceLaserCutting",
                        this.editImgServiceLaserCutting ? "aplica" : "no_aplica"
                    );
                    formData.append(
                        "editImgServiceWeldingElectrode",
                        this.editImgServiceWeldingElect ? "aplica" : "no_aplica"
                    );
                    formData.append(
                        "editImgServiceWeldingMig",
                        this.editImgServiceWeldingMig ? "aplica" : "no_aplica"
                    );
                    formData.append(
                        "editImgServiceRolled",
                        this.editImgServiceRolled ? "aplica" : "no_aplica"
                    );
                    formData.append(
                        "editImgServiceRolledC",
                        this.editImgServiceRolledC ? "aplica" : "no_aplica"
                    );
                    formData.append("editImgServicePunching1", this.editImgServicePunching1);
                    formData.append("editImgServicePunching2", this.editImgServicePunching2);
                    formData.append("editImgServiceConvex", "no_aplica");
                    formData.append("editImgServiceEyelashed", "no_aplica");
                }
                //Development
                this.notChangeConceptionLength ? formData.delete("editImageConceptionLength") : formData.append("editImageConceptionLength", this.editConceptionLength);
                this.notChangeConceptionWidth ? formData.delete("editImageConceptionWidth") : formData.append("editImageConceptionWidth", this.editConceptionWidth);
                this.notChangeShearCutConception ? formData.delete("editImgServiceShearCutConception") : formData.append("editImgServiceShearCutConception", this.editImgServiceShearCutConception === "" ? "no_aplica" : this.editImgServiceShearCutConception);
                this.notChangeOtherCutServicesConception ? formData.delete("editImgOtherServicesConception") : formData.append("editImgOtherServicesConception", this.editOtherCuttingServicesConception === "" ? "no_aplica" : this.editOtherCuttingServicesConception);
                // formData.append("editImageOrder", this.editImageOrder);
                try {
                    let res = await axios.post(
                        RUTA_SERVIDOR + "api/sheet/image/update",
                        formData,
                        {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                Authorization: "Bearer " + localStorage.getItem("token"),
                            },
                        }
                    );
                    console.log(res.data);
                    if (!res.data) {
                        console.log("There has been a different error with the data.");
                    } else {
                        alert("Forma: " + this.editImageForm + ", actualizada con exito!");
                        this.cleanFields();
                    }
                } catch (err) {
                    console.log(`There has been an error ${err}`);
                    alert("Ups, algo salio mal!");
                }
                this.$emit("hideEditForm", false);
                location.reload();
            }
        },
        async getSheetInfo() {
            try {
                if (!this.sendImageId) {
                    console.log("Sheet form id not defined.");
                    return;
                }
                const res = await axios.get(RUTA_SERVIDOR + "api/sheet/image/get", {
                    params: {
                        sheetImg_id: this.sendImageId,
                    },
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                });
                this.imgSheetForm = res.data[0];
                this.imgSheetFormFamilyName = res.data[0]["imageFormFamily"]["name"];
                this.imgSheetForm.imgServiceShearCutConception === "no_aplica" ? this.shearCutConceptionFlag = true : this.shearCutConceptionFlag;
                this.imgSheetForm.imgOtherCuttingServicesConception === "no_aplica" ? this.otherCutServicesConceptionFlag = true : this.otherCutServicesConceptionFlag;
            } catch (err) {
                console.log(`An error has occurred: ${err}`);
            }
        },
        close() {
            this.imgSheetForm = [];
            this.$emit("hideEditForm", false);
        },
        cleanFields() {
            this.editImageForm = "";
            this.editImageFile = null; // o this.imageFile = undefined;
            this.currentFile = null; // Restablece también la variable si es necesario
            this.editImageDistances = 0;
            this.editImageAngles = 0;
            this.editImageDiameters = 0;
            this.editImageRadius = 0;
            this.editConceptionLength = "";
            this.editConceptionWidth = "";
            this.editImgServiceFold = "";
            this.editImgServiceShearCut = false;
            this.editImgServiceFlamingCut = false;
            this.editImgServicePlasmaCutting = false;
            this.editImgServiceLaserCutting = false;
            this.editImgServiceWeldingElect = false;
            this.editImgServiceWeldingMig = false;
            this.editImgServiceRolled = false;
            this.editImgServiceRolledC = false;
            this.editImgServicePunching1 = "";
            this.editImgServicePunching2 = "";
            this.editImgServiceShearCutConception = "";
            this.editOtherCuttingServicesConception = "";
        }
    },
    mounted() {
        this.getSheetInfo();
    }
}
</script>
<style scoped>
.requiredFields {
    color: #9d0e15;
}
</style>